<template>
  <div class="page-form page-base">
    <h3 class="title">存新酒地址配置</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button name="返回" type="primary" @click="$router.go(-1)" />
        <form-button name="提交" type="primary" @click="saveSetting" />
      </div>
      <el-form inline ref="form" :show-message="false" size="mini" label-width="100px" :model="conditions" :rules="rules">
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系人" prop="c_o_name" required>
              <el-input v-model="conditions.c_o_name" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系电话" prop="tel_number" required>
              <el-input v-model="conditions.tel_number" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="省份" prop="region" required>
              <el-select v-model="conditions.region" clearable @change="changeRegion">
                <el-option
                  v-for="item in provinceList"
                  :key="item.BLAND"
                  :value="item.BLAND"
                  :label="item.BEZEI"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="城市" prop="city_code" required>
              <el-select v-model="conditions.city_code" clearable @change="changeCity">
                <el-option
                  v-for="item in cityList"
                  :key="item.CITY_CODE"
                  :value="item.CITY_CODE"
                  :label="item.CITY_NAME"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="区县" prop="streetcode" required>
              <el-select v-model="conditions.streetcode" clearable @change="changeStreet">
                <el-option
                  v-for="item in steetList"
                  :key="item.STRT_CODE"
                  :label="item.MC_STREET"
                  :value="item.STRT_CODE"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24" :md="12">
            <el-form-item label="联系地址" prop="street" required>
              <el-input v-model="conditions.street" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>

</template>

<script>

import { Message } from 'element-ui'
import { apiCxjAddrMod } from '@/api/sap/client-sap'
import { getArea } from '@/api/sap/common-sap'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      conditions: {
        deptName: '',
        createdById: '',
        createdByName: '',
        createdDate: '',
        value: '',
      },
      provinceList: [],
      cityList: [],
      steetList: [],
      errorList: [],
      rules: {
        c_o_name: [{ required: true, message: '请填写联系人', trigger: 'change' }],
        tel_number: [{ required: true, message: '请填写联系人', trigger: 'change' }],
        plan_type: [{ required: true, message: '请选择计划类型', trigger: 'change' }],
        region: [{ required: true, message: '请选择省份', trigger: 'change' }],
        city_code: [{ required: true, message: '请选择从城市', trigger: 'change' }],
        streetcode: [{ required: true, message: '请选择区县', trigger: 'change' }],
        street: [{ required: true, message: '请填写详细地址', trigger: 'change' }],
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    getArea().then(res => {
      this.provinceList = res.DATA || []
    })
    this.queryData()
  },
  methods: {
    async changeRegion(e) {
      if (e) {
        getArea(e, 'city').then(res => {
          this.cityList = res.DATA
        })
        this.conditions.REGION_T = this.provinceList.find(v => v.BLAND === e)?.BEZEI
      } else {
        this.conditions.REGION_T = ''
        this.cityList = []
        this.steetList = []
      }
    },
    async changeCity(e) {
      if (e) {
        getArea(e, 'street').then(res => {
          this.steetList = res.DATA
        })
        this.conditions.CITY_CODE_T = this.cityList.find(v => v.CITY_CODE === e)?.CITY_NAME
      } else {
        this.conditions.CITY_CODE_T = ''
        this.steetList = []
      }
    },
    changeStreet(e) {
      if (e) {
        this.conditions.STREETCODE_T = this.steetList.find(v => v.STRT_CODE === e)?.MC_STREET
      } else {
        this.conditions.STREETCODE_T = ''
      }
    },
    async queryData(){
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        mode: 'SELECT',
      }
      const res = await apiCxjAddrMod(params)
      this.conditions = { ...res.data }
      this.changeRegion(res.data.region)
      this.changeCity(res.data.city_code)
    },
    async saveSetting() {
     this.errorList = []
     this.$refs.form.validate(async(val, err) => {
        if (val) {
          const params = {
            user_bp: this.$store.getters.role.USER_BP,
            mode: 'UPDATE',
            data: this.conditions
          }
          const res = await apiCxjAddrMod(params)
          if(res.msgtype === 'S'){
            Message.warning('提交成功')
            this.queryData()
          }else{
            return Message.warning(res.message)
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
     })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/newWineAddress.vue